import { DOCS_FORM_NAMES } from "core/consts";
import type { PdfCreatorProps } from "../..";
import { FieldConfig, createDischargeLetterPdf } from "../pdfCreationUtils";

export const NEUROSURGERY_FIELD_CONFIG: Array<
  FieldConfig<typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY>
> = [
  {
    key: "diagnoses",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.diagnosisLabel,
  },
  {
    key: "therapy",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.therapyLabel,
  },
  {
    key: "anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.anamnesisLabel,
  },
  {
    key: "social_anamnesis",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.socialAnamnesis,
  },
  {
    key: "allergies",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.allergiesLabel,
  },
  {
    key: "admission_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery
        .admissionFindingsLabel,
  },
  {
    key: "findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.findingsLabel,
  },
  {
    key: "lab_results",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.labResultsLabel,
  },
  {
    key: "ecg",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.ecgLabel,
  },
  {
    key: "further_diagnostic_findings",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery
        .furtherFindingsLabel,
  },
  {
    key: "clinical_course",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.historyLabel,
  },
  {
    key: "admission_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery
        .admissionMedicationLabel,
  },
  {
    key: "discharge_medications",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery
        .dischargeMedicationLabel,
  },
  {
    key: "recommendations",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery
        .recommendationsLabel,
  },
  {
    key: "appointments",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.appointmentsLabel,
  },
  {
    key: "laboratory_parameters",
    label: (translations) =>
      translations.extractDocs.dischargeLetter.formNeuroSurgery.parametersLabel,
  },
];

export function createNeurosurgeryDischargeLetterPdf(
  props: PdfCreatorProps<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY
  >,
) {
  return createDischargeLetterPdf<
    typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY
  >(props, NEUROSURGERY_FIELD_CONFIG);
}
